import { createRoute } from '@tanstack/react-router'

import { Route as rootRoute } from './__root'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '*',
  component: () => (
    <div className="flex min-h-screen items-center justify-center p-6">
      <p className="text-foreground text-sm">Not found.</p>
    </div>
  ),
})
